import { render, staticRenderFns } from "./seminar.vue?vue&type=template&id=6674b9db&"
import script from "./seminar.vue?vue&type=script&lang=js&"
export * from "./seminar.vue?vue&type=script&lang=js&"
import style0 from "./seminar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports